import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { Modal, Input, message, Popconfirm, Spin, Button, Radio, Checkbox, Icon, Slider } from 'antd';
import UploadImgModule from './UploadImgModule';

const { TextArea } = Input;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;

const radioStyle = {
  display: 'block',
  height: '30px',
  lineHeight: '30px',
  verticalAlign: 'middle',
};

export default class TextQuestionEditModule extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    let area = props.area;
    this.state = {
      role: CurrentRoleStore.getCurrentRole(),
      pageId: props.pageId,
      studentIds: props.studentIds,
      area,
      questions: area.question_areas,
      template:{},

      pageContentId: null,

      radioValue: [],
      checkboxValue: [],
      text: undefined,
      answers: [],
      temp_Answer: [],
    };
    // bind this
    this.toolAnswers = this.toolAnswers.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getLength = this.getLength.bind(this);
    this.textBindblur = this.textBindblur.bind(this);
    this.handleFillingInput = this.handleFillingInput.bind(this);
    this.submit = this.submit.bind(this);
    this._questionDetailView = this._questionDetailView.bind(this);

    this.handleCommentChange = this.handleCommentChange.bind(this);

    this.callbackUploadFile = this.callbackUploadFile.bind(this);

  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onRolesChange);
    let temp_Answer = [];
    this.state.questions.forEach((question) => {
      if (question.type == "Filling" || question.type == "Text") {
        if (question.hasAnswer) {
          temp_Answer.push({key: question.id, answer: question.questionToJson.answer.answer});
        } else {
          if (question.type == "Filling") {
            let answer = [];
            for (var i=0; i<question.blank_count; i++){
              answer[i] = '';
            }
            temp_Answer.push({key: question.id, answer: answer});
          } else if (question.type == "Text") {
            temp_Answer.push({key: question.id, answer: ''});
          }
        }
      } else if(question.type == "Choice") {
        if (question.hasAnswer) {
          let option = question.questionToJson.options.find((option) => option.sequence == question.questionToJson.answer.answer);
          option.checked = true;
          temp_Answer.push({ key: question.id, answer: question.questionToJson.answer.answer, comment: question.questionToJson.answer.comment });
        } else {
          temp_Answer.push({ key: question.id, answer: '', comment: '' });
        }

      } else if (question.type == "MultiChoice") {
        if (question.hasAnswer) {
          question.questionToJson.options.map((option) => {
            question.questionToJson.answer.answer.forEach((answer) => {
              if (option.sequence == answer) {
                option.checked = true;
              }
            })
          })
          temp_Answer.push({ key: question.id, answer: question.questionToJson.answer.answer, comment: question.questionToJson.answer.comment });
        } else {
          temp_Answer.push({ key: question.id, answer: '', comment: '' });
        }

      }
    })
    this.toolShowCondition(this.state.area.question_areas)
    this.setState({
      area: this.state.area,
      temp_Answer: temp_Answer,
    })
  }

  componentWillUnmount() {
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  componentWillReceiveProps(newProps){
    let temp_Answer = [];
    let area = newProps.area;
    this.toolShowCondition(area.question_areas);

    area.question_areas.forEach((question) => {
      if (question.type == "Filling" || question.type == "Text") {
        if (question.hasAnswer) {
          temp_Answer.push({key: question.id, answer: question.questionToJson.answer.answer});
        } else {
          if (question.type == "Filling") {
            let answer = [];
            for (var i=0; i<question.blank_count; i++){
              answer[i] = '';
            }
            temp_Answer.push({key: question.id, answer: answer});
          } else if (question.type == "Text") {
            temp_Answer.push({key: question.id, answer: ''});
          }
        }
      }
    })
    this.setState({
      area,
      questions: area.question_areas,
      temp_Answer: temp_Answer,
    })
  }

  // 根据选项显示问题
  toolShowCondition(questions, index) {
    let hideQuestions = questions.filter((question) => {
      let q = question.questionToJson;
      // 筛选需要条件显示的
      if (q.show_condition && q.show_condition.length > 0) {
        if (index) {
          let status = false;
          q.show_condition.forEach((condition) => {
            // 筛选跟当前题目有关联的
            if (condition.sequence - 1 == index) {
              status = true;
            }
          })
          return status;
        } else {
          return true;
        }
      }
    });

    hideQuestions.map((q) => {
      let status = true;
      q.questionToJson.show_condition.forEach((condition) => {
        if (!questions[condition.sequence - 1].hideStatus) {
          let checkedArr = questions[condition.sequence - 1].questionToJson.options.filter((option) => option.checked);
          condition.options.findIndex((option) => {
            let i = checkedArr.findIndex((item) => item.sequence == option);
            if (i < 0) {
              status = false;
            }
          })
        } else {
          status = false;
        }
      })
      q.hideStatus = !status;
    })
  }

  toolQuestionType(type) {
    type = type.split('::')[1];
    return type;
  }

  toolAnswers(index, pushAnswer) {
    index = Number(index);
    var that = this;
    if (pushAnswer && index < pushAnswer.length) {
      let { hasAnswer, questionId, data } = pushAnswer[index];
      data.role = this.state.userRole;
      DataService.toolAnswers(hasAnswer, questionId, data).then((res) => {
        that.toolAnswers(index + 1, pushAnswer);
      }).catch((error) => {
        console.log("提交失败")
        that.setState({
          btnState: {
            disabled: false,
            loading: false,
            text: '确认',
          }
        })
        console.log(error);
      })
    } else {
      this.state.questions.map((question)=>{
        pushAnswer.forEach((item) => {
          if (question.id == item.questionId) {
            question.hasAnswer = true;
          }
        })
      })
      this.props.onUpdate(this.state.area.id, this.state.questions)
    }
  }

  callbackUploadFile(uploadImgs, questionId) {
    let photos = [];
    uploadImgs.forEach((img) => {
      if (img.remote_url) {
        photos.push({ width: img.info.w, height: img.info.h, url: img.remote_url })
      } else {
        photos.push(img)
      }
    })
    this.state.questions.map((question) => {
      if (question.id == questionId && question.type == "MultiImage") {
        if (question.questionToJson.answer) {
          question.questionToJson.answer.answer = photos;
        } else {
          question.questionToJson.answer = {
            answer: photos
          };
        }
      } else if (question.id == questionId && question.type == "Text") {
        if (question.questionToJson.answer) {
          question.questionToJson.answer.photos = photos;
          question.questionToJson.answer.answer = question.questionToJson.answer.answer ? question.questionToJson.answer.answer : '';
        } else {
          question.questionToJson.answer = {
            photos,
            answer: ''
          };
        }
      } else if (question.id == questionId && (question.type == "Choice" || question.type == "MultiChoice")) {
        if (question.questionToJson.answer) {
          question.questionToJson.answer.photos = photos;
        } else {
          question.questionToJson.answer = {};
          question.questionToJson.answer.photos = photos;
        }
      }
    })
    this.setState({
      questions: this.state.questions,
      changeState: true
    })    
    
  }

  _questionDetailView(question) {
    let q = question.questionToJson, area = this.state.area;
    let that  = this;

    switch (question.type) {

      case "Filling":
        return (
          <div key={area.id + '-' + question.id} style={{width: "420px"}}>
            <div className="question-title">{question.is_optional ? '' : <span className="red-point">*</span>}填空题</div>
            <div className="question-description">
              {q.titleArray.map(function(text,index){
                return(
                  <div key={index} style={{display: 'inline-block'}}>
                    <span>{text}</span>
                    {index < (q.titleArray.length - 1) &&
                      <Input className="filling-input-text" onChange={that.handleFillingInput} placeholder="点击添加" value={q.answer ? (q.answer.answer[index] ? q.answer.answer[index] : '') : ''} data-id={question.id} data-key={index} style={{width:q.lengths[index]*20+'px'}} maxLength={q.lengths[index].toString()} />
                    }
                  </div>
                )
              }
              )}
            </div>
          </div>
        )

      case "Text":
        return (
          <div key={area.id + '-' + question.id} style={{width: "420px"}}>
            <div className="question-title">{question.is_optional ? '' : <span className="red-point">*</span>}文字题{q.title ? "： "+q.title : ""}</div>
            <TextArea autosize className="question-text-input" onChange={this.handleChange} onBlur={this.textBindblur} data-id={question.id} placeholder={q.description ? q.description : '请输入文本'} maxLength="-1" defaultValue={q.answer ? q.answer.answer : (q.auto_complete ? q.auto_complete  : '')} style={{resize:"none", wordWrap: "break-word"}} />
            <span className={"text-count"+(this.getLength(question.id) > q.count ? " red" : "")}><span>{this.getLength(question.id)}</span>/{q.count}</span>
            {(q.photo_count && q.photo_count > 0) ? <UploadImgModule photo_count={q.photo_count} callbackUploadFile={this.callbackUploadFile} questionId={question.id} uploadedFiles={(q.answer && q.answer.photos) ? q.answer.photos : []}/> : ''}
          </div>
        )
      
      case "MultiImage":
        return (
          <div key={area.id + '-' + question.id} style={{width: "420px"}}>
            <div className="question-title">{question.is_optional ? '' : <span className="red-point">*</span>}{q.title ? q.title : ""}</div>
            <UploadImgModule photo_count={q.photo_count ? q.photo_count : 100} callbackUploadFile={this.callbackUploadFile} questionId={question.id} uploadedFiles={(q.answer && q.answer.answer) ? q.answer.answer : []}/>
          </div>
        )

      case "Choice":
        return (
          <div key={area.id + '-' + question.id} style={{width: "420px"}}>
            <div className="question-title">{question.is_optional ? '' : <span className="red-point">*</span>}单选题{q.title ? "： "+q.title : ""}</div>
            <div className="options-box">
              <RadioGroup defaultValue={question.hasAnswer ? parseInt(q.answer.answer):""} >
                {q.options.map((option)=>
                  <Radio onClick={this.handleChange} data-id={question.id} data-answer={option.sequence} key={option.sequence} style={radioStyle} value={option.sequence}>{option.option}</Radio>
                )}
              </RadioGroup>
              {q.should_comment ? <TextArea autosize className="question-text-input choice-text-input" onChange={this.handleCommentChange} onBlur={this.textCommentBindblur} data-id={question.id} placeholder={q.description ? q.description : '请输入文本'} maxLength="-1" defaultValue={q.answer ? q.answer.comment : (q.auto_complete ? q.auto_complete : '')} style={{ resize: "none", wordWrap: "break-word" }} /> : ''}
              {q.should_comment ? <span className={"text-count" + (((q.answer && q.answer.comment) ? q.answer.comment.length : 0) > q.count ? " red" : "")}><span>{(q.answer && q.answer.comment) ? q.answer.comment.length : 0}</span>/{q.comment_count}</span> : ''}
              {(q.photo_count && q.photo_count > 0) ? <UploadImgModule photo_count={q.photo_count} callbackUploadFile={this.callbackUploadFile} questionId={question.id} uploadedFiles={(q.answer && q.answer.photos) ? q.answer.photos : []} /> : ''}
              
            </div>
          </div>
        )

      case "MultiChoice":
        return (
          <div key={area.id + '-' + question.id} style={{width: "420px"}}>
            <div className="question-title">{question.is_optional ? '' : <span className="red-point">*</span>}多选题{q.title ? "： "+q.title : ""}</div>
            <div className="options-box">
              <Checkbox.Group defaultValue={question.hasAnswer ? q.answer.answer : []}>
                {q.options.map((option) =>
                  <Checkbox onClick={this.handleChange} data-id={question.id} data-answer={option.sequence} key={option.sequence} style={radioStyle} value={option.sequence}>{option.option}</Checkbox>
                )}
              </Checkbox.Group>
              {q.should_comment ? <TextArea autosize className="question-text-input choice-text-input" onChange={this.handleCommentChange} onBlur={this.textCommentBindblur} data-id={question.id} placeholder={q.description ? q.description : '请输入文本'} maxLength="-1" defaultValue={q.answer ? q.answer.comment : (q.auto_complete ? q.auto_complete : '')} style={{ resize: "none", wordWrap: "break-word" }} /> : ''}
              {q.should_comment ? <span className={"text-count" + (((q.answer && q.answer.comment) ? q.answer.comment.length : 0) > q.count ? " red" : "")}><span>{(q.answer && q.answer.comment) ? q.answer.comment.length : 0}</span>/{q.comment_count}</span> : ''}
              {(q.photo_count && q.photo_count > 0) ? <UploadImgModule photo_count={q.photo_count} callbackUploadFile={this.callbackUploadFile} questionId={question.id} uploadedFiles={(q.answer && q.answer.photos) ? q.answer.photos : []} /> : ''}
              
            </div>
          </div>
        )
      // ==============多选题============== //
      // <div className="question-box">
      //   <div className="question-title">选择题</div>
      //   <div className="question-cancel"></div>
      //   <div className="question-description">多选题：题目文字题目文字题目文字</div>
      //   <div className="options-box">
      //     <CheckboxGroup  onChange={this.handleChange} defaultValue={question1.answer}>
      //       {question1.options.map((option)=>
      //         <Checkbox key={option.sequence} style={radioStyle} value={option.sequence}>{option.option}</Checkbox>
      //       )}
      //     </CheckboxGroup>
      //   </div>
      //   <div className="question-footer">
      //     <Button className="question-footer-btn">确 认</Button>
      //   </div>
      // </div>
    }
  }

  //upload
  getAvailableQuotaForUploadingFiles() {
    return true;
  }

  isAllUploadingFileFinished() {
    return !this.state.uploading;
  }

  onFileStartUpload(newFileKey) {
    this.setState({
      uploading: true
    })
    return true;
  }

  onFileUploadSuccess(newFileKey, fileName, size, remoteUrl) {
    
  }

  //fill questions
  handleChange(e){
    let answers = e.target.value, questions = this.state.questions, area = this.state.area;

    let question = questions.find((q) => q.id == e.currentTarget.dataset.id);
    let index = questions.findIndex((q) => q.id == e.currentTarget.dataset.id);

    if (question.type == 'Choice') {
      answers = e.currentTarget.dataset.answer;
      question.questionToJson.options.map((option) => {
        option.checked = false;
        if (option.sequence == answers){
          option.checked = true;
          question.questionToJson.answer = question.questionToJson.answer ? question.questionToJson.answer : {};
          question.questionToJson.answer.answer = answers;
        }
      })

      this.toolShowCondition(questions, index);
      this.toolShowCondition(area.question_areas, index);

      this.setState({
        questions,
        area,
        changeState: true
      })
    } else if (question.type == 'Text') {
      let answer = this.state.temp_Answer.find((answer) => answer.key == e.currentTarget.dataset.id);
      answer.answer = answers;

      this.setState({
        temp_Answer: this.state.temp_Answer,
        changeState: true
      })

    } 
    // 支持多选
    else if (question.type == 'MultiChoice') {
      answers = e.currentTarget.dataset.answer;
      question.questionToJson.answer = question.questionToJson.answer ? question.questionToJson.answer : {};
      question.questionToJson.answer.answer = [];
      question.questionToJson.options.map((option) => {
        if (option.sequence == answers) {
          option.checked = option.checked ? false : true;
        }
        if (option.checked) {
          question.questionToJson.answer.answer.push(option.sequence)
        }
      })

      question.questionToJson.options.map((option) => {
        if (option.checked) {
          return option.sequence;
        }
      })

      this.toolShowCondition(questions, index);
      this.toolShowCondition(area.question_areas, index);

      this.setState({
        questions,
        area,
        changeState: true
      })
    }
  }
  
  handleCommentChange(e) {
    let answers = e.target.value;
    let question = this.state.questions.find((q) => q.id == e.currentTarget.dataset.id);
    question.questionToJson.answer = question.questionToJson.answer ? question.questionToJson.answer : {};
    question.questionToJson.answer.comment = answers;

    this.setState({
      question,
      changeState: true
    })
  }


  handleFillingInput(e) {
    let question = this.state.questions.find((q) => q.id == e.currentTarget.dataset.id);
    let answer = this.state.temp_Answer.find((answer) => answer.key == e.currentTarget.dataset.id);
    let q = question.questionToJson;
    answer.answer[e.currentTarget.dataset.key] = e.target.value;

    q.answer =  q.answer ?  q.answer : {};
    q.answer.answer =  q.answer.answer ?  q.answer.answer : [];

    q.answer.answer[e.currentTarget.dataset.key] = e.target.value;
    this.setState({
      questions: this.state.questions,
      temp_Answer: this.state.temp_Answer,
      changeState: true
    })
  }

  textBindblur(e) {
    let question = this.state.questions.find((q) => q.id == e.currentTarget.dataset.id);
    let answer = this.state.temp_Answer.find((answer) => answer.key == e.currentTarget.dataset.id);
    question.questionToJson.answer = question.questionToJson.answer ? question.questionToJson.answer : {};
    question.questionToJson.answer.answer = SharedTools.cloneObject(answer.answer);
    this.setState({
      questions: this.state.questions
    })
  }

  getLength(id) {
    var answer = this.state.temp_Answer.filter(function(answer) {return answer.key == id});
    if(answer.length > 0){
      return answer[0].answer.length;
    }else {
      return 0;
    }
  }

  submit() {
    this.setState({
      btnState: {
        disabled: true,
        loading: true,
        text: '正在提交中..'
      }
    })

    // 判断是否有答案未填写
    let submitAbled = true, error = "", questions = this.state.questions.filter((question) => !question.hideStatus);
    questions.forEach((question, key) => {
      if (question.type == 'Text') {
        if(question.questionToJson.answer){
          if (!question.questionToJson.answer.answer && !question.questionToJson.auto_complete && !question.is_optional) {
            submitAbled = false;
            error = error ? error : ("请完成题目" + (key + 1));
          } else if (!question.questionToJson.answer.answer && question.questionToJson.auto_complete) {
            question.questionToJson.answer.answer = question.questionToJson.auto_complete;
            this.setState({
              changeState: true
            })
          } else {
            if (question.questionToJson.answer.answer && (question.questionToJson.answer.answer.length > question.questionToJson.count) && error == '') {
              error = (error ? error : '题目' + (key + 1) + '已超出字数为' + question.questionToJson.count + '的限制');
            }
          }
        } else {
          if (!question.is_optional) {
            submitAbled = false;
            error = (error ? error : "请完成题目" + (key + 1));
          }
        }
      }
      else if (question.type == 'Choice') {
        let checkedState = false;
        if (question.questionToJson.answer) {
          checkedState = true
        }
        if (!checkedState && !question.is_optional) {
          submitAbled = false;
          error = (error ? error : "题目" + (key + 1) + "为必填项");
        }
      }
      else if (question.type == 'MultiChoice') {
        let checkedState = false;
        if (question.is_optional) {
          checkedState = true;
        } else {
          if (question.questionToJson.answer && question.questionToJson.answer.answer && question.questionToJson.answer.answer.length > 0) {
            checkedState = true;
          }
        }
        if (!checkedState) {
          submitAbled = false;
          error = (error ? error : "题目" + (key + 1) + "为必填项");
        }
      }
      else if (question.type == 'Filling') {
        if(question.questionToJson.answer){
          if (question.questionToJson.blank_count != question.questionToJson.answer.answer.length) {
            submitAbled = false;
            error = (error ? error : "请完成题目" + (key + 1));
          } else {
            question.questionToJson.answer.answer.forEach((answer, index) => {
              if (!answer) {
                submitAbled = false;
                error = (error ? error : "请完成题目" + (key + 1));
              } else {
                if ((answer.length > question.questionToJson.lengths[index]) && error == '') {
                  error = (error ? error : '题目' + (key + 1) + '中的第' + (index + 1) + '个填空已超出字数为' + question.questionToJson.lengths[index] + '的限制')
                }
              }
            })
          }
        } else {
          if (!question.is_optional) {
            submitAbled = false;
            error = (error ? error : "题目" + (key + 1) + "为必填项");
          }
        }
      }
      else if (question.type == "MultiImage") {
        if ((!question.questionToJson.answer || question.questionToJson.answer.answer.length <= 0) && !question.is_optional) {
          submitAbled = false;
          error = '上传照片不能为空';
        }
      }
    })

    if (submitAbled && !error) {
      let auto_complete = true;
      questions.forEach((question, index) => {
        if (!question.questionToJson.auto_complete) {
          auto_complete = false;
        }
      })
      if (this.state.changeState || auto_complete) {
        let p = [], count = 0;
        questions.forEach((question, index) => {
          let data = {}, questionId;
          data.answer = {};
          if (question.type == 'Text' && question.questionToJson.answer) {
            data.answer = question.questionToJson.answer;
            questionId = question.id;
          }
          else if (question.type == 'Choice' || question.type == 'MultiChoice') {
            data.answer = question.questionToJson.answer;
            questionId = question.id;
          }
          else if (question.type == 'Filling' && question.questionToJson.answer) {
            data.answer.answer = question.questionToJson.answer.answer;
            questionId = question.id;
          }
          else if (question.type == 'MultiImage' && question.questionToJson.answer && question.questionToJson.answer.answer) {
            data.answer = question.questionToJson.answer;
            questionId = question.id;
          }
          data.answer = JSON.stringify(data.answer);
          data.page_id = this.state.pageId;
          data.student_ids = JSON.stringify(this.state.studentIds);
          if (questionId) {
            p[count] = {
              hasAnswer: question.hasAnswer,
              questionId: questionId,
              data: data,
            }
            count++;
          }

        })
        this.toolAnswers(0, p);
      } else {
        this.props.onCancel()
      }
    } else if (error) {
      message.error(error)
      this.setState({
        btnState: {
          disabled: false,
          loading: false,
          text: '确认'
        }
      })
    }

  }

  render() {
    return (
      <div className="question-box">
        <div className="question-cancel" onClick={this.props.onCancel}></div>
        <div className="question-content">
          {this.state.questions && this.state.questions.map((question) => {
            if (!question.hideStatus) {
              return this._questionDetailView(question)
            }}
          )}
        </div>
        <div className="question-footer">
          <Button className="question-footer-btn" onClick={this.submit}>确 认</Button>
        </div>
      </div>
    )
  }
}

// <ReactQiniuModule
//     className="edit-cover"
//     onSuccess={this.onFileUploadSuccess}
//     onStartPermit={this.onFileStartUpload}
//     isAllFinish={this.isAllUploadingFileFinished}
//     getUploadQuota={this.getAvailableQuotaForUploadingFiles}
//     allowUploadFileTypes={ReactQiniuModule.getFileCategories.ALL}
//     allowUploadFileSize={10} >
//   {this.state.uploading &&
//     <Spin tip="Loading...">
//       <img src={this.state.album.cover} className="albums-detail-cover-img" />
//     </Spin>
//   }
//   {!this.state.uploading &&
//     <img src={this.state.album.cover} className="albums-detail-cover-img" />
//   }
//   <div className="albums-detail-cover-img-text" onClick={this.uploadAvatar}>更换照片</div>
// </ReactQiniuModule>


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/archive/TextQuestionEditModule.jsx